<template>
  <div>
    <div class="face-container" @click="photograph">
      <div v-if="videoError" class="face-tip flex flex-x">{{videoError}}</div>
      <div v-else class="face-tip">
        <div class="tip" v-if="type==1||type==6">保持面部在框定范围内</div>
        <div class="tip" v-else-if="type==2||type==3">请将舌头靠近摄像头</div>
        <div class="tip" v-else>请将舌头抵住上颚，尽量露出舌底</div>
        <div class="tip col">点击屏幕拍摄</div>
      </div>
      <div class="face-camera" :class="{
            'faceFrame':faceFrame==2
      }">
        <img v-if="faceFrame!==2" src="../../../images/face_bg.png" alt=" " class="face_bg"/>
        <div class="video">
          <canvas ref="canvas" style="display: none"></canvas>
          <video ref="video" :class="{
            'rotate90':rotate90==2,
            'rotate-90':rotate90==3,
            'rotate180':rotate90==4
          }" autoplay ></video>
        </div>
      </div>
      <div class="face-con"/>
    </div>
    <div class="loading flex flex-x flex-y" v-if="loading">
        <div class="loading-box">
          <div class="loading-icon">
            <van-loading />
            <div class="loading-ui">上传中</div>
          </div>
        </div>
      </div>
      <div class="loading black flex flex-x flex-y" v-if="no_show">
          <div class="loading-box">
              <div class="load-bac">
                <img src="../../../images/false.png" alt=" " class="icon-img"/>
                <div class="load-no">{{no_show}}</div>
                <div @click="previewFun">
                  <img src="../../../images/face1.png" alt=" " class="load-img" v-if="type==1"/>
                  <img src="../../../images/tongues.png" alt=" " class="load-img" v-else/>
                </div>
                <div class="again" @click="photoFun">重新检测</div>
              </div>
          </div>
      </div>
      <div class="loading black flex flex-x flex-y" v-if="explain">
          <div class="loading-box">
              <div class="load-bac">
                <img src="../../../images/status-ok.png" alt=" " class="icon-img"/>
                <div class="load-explain">{{explain}}</div>
              </div>
          </div>
      </div>
      <div v-if="dialog" class="loading black flex flex-x flex-y">
        <div class="loading-box">
            <div class="load-bac load-dialog">
              <div class="load-explain">光线太暗或舌伸太短，会影响检测结果，建议重拍</div>
              <div class="dialog-box flex">
                <div class="flex-1 dialog-user" @click="phokFun">使用照片</div>
                <div class="flex-1 dialog-again" @click="photoFun">重新拍摄</div>
              </div>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
  import "./camera.scss";
  import { mapActions , mapMutations , mapState } from "vuex";
  import { ImagePreview } from 'vant';
  export default {
    name: "camera",
    data () {
      return {
        imgSrc: "",
        videoError:"",
        stream:null,
        rotate90:1,
        faceFrame:1
      };
    },
    props: ["type"],
    created: function () {
      let equipment = sessionStorage.equipment;
      if(equipment){
        equipment = JSON.parse(equipment);
        this.rotate90 = equipment.camera_rotation;
        this.faceFrame = equipment.face_frame;
      }
      if (sessionStorage && (sessionStorage.device === "android" && !sessionStorage.camera)) {
        if(sessionStorage.native){
          this.startNativeAndroidCamera();
        }else{
          this.startUpAndroidCamera ();
        }
      } else {
        this.startUpWebCamera ();
      }
    },
    computed:{
      ...mapState('step',['show','loading','no_show','explain','dialog','errorImg']),
    },
    beforeDestroy(){
      if(this.stream){
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }
    },
    methods: {
      //使用图片
      phokFun(){
        this.phoFun({
          _this:this,
          type:this.$props.type
        })
      },
      previewFun(){
        ImagePreview([this.errorImg]);
      },
      // 启动H5摄像头
      startUpWebCamera () {
        if (navigator.mediaDevices) {
          navigator.mediaDevices.getUserMedia({ audio: false, video: true })
            .then(stream => {
              // 1. 先缓存流（保留你的核心需求）
              this.stream = stream;
              const videoElement = this.$refs["video"];
              
              // 2. 先暂停可能的播放，避免状态冲突
              if (!videoElement.paused) {
                videoElement.pause().catch(() => {});
              }
              
              // 3. 赋值流并立即触发播放（合并执行，减少异步延迟）
              videoElement.srcObject = stream;
              
              // 4. 监听视频就绪事件，确保在就绪后播放（关键优化）
              const handleCanPlay = () => {
                videoElement.play().catch(playErr => {
                  console.warn("视频播放失败:", playErr);
                });
                // 移除一次性监听，避免内存泄漏
                videoElement.removeEventListener('canplay', handleCanPlay);
              };
              
              videoElement.addEventListener('canplay', handleCanPlay);
            })
            .catch(err => {
              if (err.name === "NotAllowedError") {
                this.videoError = "用户拒绝了权限请求";
              } else if (err.name === "NotFoundError") {
                this.videoError = "未找到可用的摄像头";
              } else if (err.name === "NotSupportedError") {
                this.videoError = "此功能仅支持 HTTPS 环境，请在 HTTPS 环境下运行";
              } else {
                this.videoError = `摄像头调用失败: ${err.message}`;
              }
              console.error("摄像头错误:", err);
            });
        }
      },
      // 启动安卓（设备端）摄像头
      startUpAndroidCamera () {
        window["ReactNativeWebView"].postMessage ("photo");
        window.obj = {};
        var _this = this;
        Object.defineProperty(window.obj, "url", {
          get: function () {
            return '';
          },
          set: function (newValue) {
            _this.axiosData({
              data:{
                photo:newValue,
                type:_this.$props.type
              },
              _this:_this
            })
          },
        });
      },

      //启动安卓原生（设备端）摄像头
      startNativeAndroidCamera(){
          let _this = this;
          window.Android.readCardBas();
          window.onReceiveFromAndroid = function(data){
            _this.axiosData({
              data:{
                photo:data,
                type:_this.$props.type
              },
              _this:_this
            })
          }
      },

      photoFun(){
        this.againFun();
        if (sessionStorage && (sessionStorage.device === "android" && !sessionStorage.camera)) {
          this.startUpAndroidCamera ();
        }
      },

      // 拍照
      photograph () {
        let canvas = this.$refs["canvas"];
        let ctx = canvas.getContext("2d");
        canvas.width = 1200;
        canvas.height = this.$refs.video.offsetHeight*(canvas.width/this.$refs.video.offsetWidth);
        ctx.drawImage(
            this.$refs.video,
            0,
            0,
            canvas.width,
            canvas.height
        );
        const image = canvas.toDataURL('image/jpeg');
        let degrees = 0;
        if(this.rotate90==2){
          degrees = 90;
        }else if(this.rotate90==3){
          degrees = -90;
        }else if(this.rotate90==4){
          degrees = 180;
        }
        let _this = this;
        this.rotateBase64Image(image, degrees).then((rotatedBase64) => {
          _this.axiosData({
            data:{
              photo:rotatedBase64,
              type:this.$props.type
            },
            _this:this
          })
        });
      },
      rotateBase64Image(base64Image, degrees) {

        if(degrees===0){
          return new Promise((resolve, reject) => {
            resolve(base64Image);
          });
        }else{
          const image = new Image();
          image.src = base64Image;

          return new Promise((resolve, reject) => {
            image.onload = () => {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");

              let outputWidth = image.width;
              let outputHeight = image.height;

              // 处理90度和-90度的情况
              if (degrees === 90 || degrees === -90) {
                outputWidth = image.height;
                outputHeight = image.width;
              }

              // 处理180度的情况
              if (degrees === 180) {
                outputWidth = image.width;
                outputHeight = image.height;
              }

              canvas.width = outputWidth;
              canvas.height = outputHeight;

              const x = canvas.width / 2;
              const y = canvas.height / 2;

              ctx.translate(x, y);
              ctx.rotate((degrees * Math.PI) / 180);
              ctx.translate(-image.width / 2, -image.height / 2);

              ctx.drawImage(image, 0, 0);

              const rotatedBase64 = canvas.toDataURL('image/jpeg', 0.9);
              resolve(rotatedBase64);
            };
            image.onerror = () => {
              reject(new Error("屏幕旋转失败！"));
            };
          });
        }
      },

      ...mapMutations ("step", ["againFun","phoFun"]),
      ...mapActions ("step", ["axiosData"])
    }
  };
</script>
